import { useState, useEffect } from "react";

export function useFirstVisit() {
  // const [showBanner, setShowBanner] = useState(false);

  // useEffect(() => {
  //   const hasVisited = localStorage.getItem("BN_FIRST_VISIT");

  //   if (!hasVisited) {
  //     setShowBanner(true);
  //   }
  // }, []);

  // const dismissBanner = () => {
  //   localStorage.setItem("BN_FIRST_VISIT", "true");
  //   setShowBanner(false);
  // };

  // return { showBanner, dismissBanner };


  const [showAppStatus, setShowAppStatus] = useState(false);
  const [storageReady, setStorageReady] = useState(false);
  const hideDiscoveryNote = localStorage.getItem("hideDiscoveryNote") === "true" ;
                            
    const interactionScore = JSON.parse(localStorage.getItem("interactionScore") || "{}");

  useEffect(() => {
    const hideDiscoveryNote =
      localStorage.getItem("hideDiscoveryNote") === "true";
  
    const interactionScore =
      JSON.parse(localStorage.getItem("interactionScore") || "{}");
  
    const savedImages =
      JSON.parse(localStorage.getItem("savedImages") || "[]");
  
    const hasInteraction = Object.keys(interactionScore).length > 0;
    const hasSavedImages = savedImages.length > 0;
  
    const shouldShow =
      !hideDiscoveryNote && !hasInteraction && !hasSavedImages;
  
    setShowAppStatus(shouldShow);
    // setShowAppStatus(true);
    setStorageReady(true);
  }, []);

    const dismissAppStatus = () => {
    localStorage.setItem("hideDiscoveryNote", "true");
    setShowAppStatus(false);
  };



  return {storageReady , showAppStatus, dismissAppStatus}

}